module.exports = __webpack_public_path__ + "img/type_keine.bb7ee6c7.svg";